// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__F3BWX","clinicsSelect":"TableHeading_clinicsSelect__27WxQ"};